<template>
  <slot
    :text="stat.text"
    :tooltip="stat.tooltip"
  >
    <div>
      <LineClamp :lines="1"> {{ stat.text }}{{ suffix }} </LineClamp>

      <StreemTooltip>
        {{ stat.tooltip }}
      </StreemTooltip>
    </div>
  </slot>
</template>

<script setup>
import { computed } from "vue";

import { LineClamp, StreemTooltip } from "shared/components/base";
import { useOutreachContactSocialStats } from "shared/composables/useOutreachContactSocialStats";

const props = defineProps({
  contact: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    required: true,
    validator: (val) => ["avgEngagement", "topReaction"].includes(val),
  },
  suffix: {
    type: String,
    default: "",
  },
});

const { stats } = useOutreachContactSocialStats(props);

const stat = computed(() => stats.value.find(({ id }) => id === props.type));
</script>
